module.exports = __webpack_public_path__ + "static/media/proworkicon_machine_edit001.6cab1b2e.png";